import {
  inactiveDriver,
  inactiveHelper
} from "@/api/frota";
import { t } from "@/lib/i18n";

const state = {
  isLoading: false,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async inactiveDriver({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);

    try {
      await inactiveDriver(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async inactiveHelper({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);

    try {
      await inactiveHelper(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },
};

const mutations = {
  cleanState(state) {
    state.isLoading = false;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
